module.exports = __webpack_public_path__ + "media/flags/ca-9e6db4a7.gif";